import * as React from 'react';
import { connect } from 'react-redux';

import Form from 'components/form/Form';
import { Loader } from 'components/loader/Loader';
import { STATUSES } from 'core/api';

import { formConfig } from './config';
import { fetchUserInfo, resetUserInfo, updateUser } from './redux';

import styles from '../users/Users.module.styl';

/**
 * DISCLAIMER: This component has been migrated from js file
 * Therefore there are so many 'any' types.
 * Please feel free to refactor it.
 */
class UserForm extends React.Component<any> {
  public get formConfig() {
    const {
      match: {
        params: { id },
      },
      references,
    } = this.props;

    const countries =
      references.status === STATUSES.SUCCESS
        ? references.data.items.countries
        : [];

    return formConfig({ userId: id, countries });
  }
  public componentDidMount(): void {
    const {
      match: {
        params: { id },
      },
    } = this.props;

    this.props.fetchUserInfo(id);
  }

  public componentWillUnmount() {
    this.props.resetUserInfo();
  }

  public onSubmit = async (values: any) => {
    const {
      match: {
        params: { id },
      },
    } = this.props;

    const valuesToSubmit = {
      countryId: values.countryId || null,
      type: values.type,
      countriesToManage: values.countriesToManage || null,
    };

    if (id) {
      await this.props.updateUser(id, valuesToSubmit);
      await this.props.fetchUserInfo(id);
    }
  };

  public render() {
    const { userInfo, userUpdate } = this.props;

    if (
      userInfo.status === STATUSES.REQUEST ||
      userUpdate.status === STATUSES.REQUEST
    ) {
      return <Loader />;
    }

    return (
      <div className={styles.root}>
        <Form
          config={this.formConfig}
          onSubmit={this.onSubmit}
          initialValues={
            userInfo.status === STATUSES.SUCCESS
              ? {
                  ...userInfo.data.data,
                  countriesToManage: userInfo.data.data.manageableCountries,
                }
              : {}
          }
        />
      </div>
    );
  }
}

const mapState = (state: any) => ({
  references: state.references,
  userInfo: state.userForm.userInfo,
  userUpdate: state.userForm.userUpdate,
});

const mapDispatch = {
  fetchUserInfo,
  resetUserInfo,
  updateUser,
};

export default connect(mapState, mapDispatch)(UserForm);
